function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import { Toast } from "../common";
import { orderGetPayInfo, orderPayByDifftype } from "../service/order";
import qs from 'query-string';
import LStorage from "./lStorage";
import { getCookie } from "./cookie";
import { ROOM_ID } from "./keys";
import { createOrderOnly } from "../service/api";
import { sensorsTrack } from "../service/sensors";
import { createModal } from "./modal";
// 支付
export var handlePay = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(props) {
    var orderInfo, payType, truename, _props$customFns;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          orderInfo = props.orderInfo, payType = props.payType; // 如果是分期支付提示填写真实姓名
          truename = '';
          if (!(payType === 4)) {
            _context.next = 7;
            break;
          }
          Toast.clear();
          _context.next = 6;
          return (_props$customFns = props.customFns) === null || _props$customFns === void 0 ? void 0 : _props$customFns.confirmInputTrueName();
        case 6:
          truename = _context.sent;
        case 7:
          Toast.show({
            content: '正在唤起支付',
            duration: 10000
          });
          // 获取支付信息
          orderGetPayInfo(orderInfo.id, payType, truename).then(function (payinfo) {
            // 如果是免费
            if (payType === 3) {
              Toast.show({
                content: '购买成功',
                duration: 3000,
                maskClickable: false
              });
              setTimeout(function () {
                var _props$customFns2;
                (_props$customFns2 = props.customFns) === null || _props$customFns2 === void 0 ? void 0 : _props$customFns2.push("/success/".concat(payinfo.orderToken));
              }, 1200);
              return;
            }
            // 支付
            orderPayByDifftype(payinfo, payType, orderInfo.payAmount).then(function (data) {
              var _props$customFns3;
              Toast.show({
                content: '支付成功',
                duration: 3000,
                maskClickable: false,
                icon: 'success'
              });
              (_props$customFns3 = props.customFns) === null || _props$customFns3 === void 0 ? void 0 : _props$customFns3.push("/success/".concat(payinfo.orderToken));
            }).catch(function (e) {
              Toast.show({
                content: '支付失败',
                icon: 'fail',
                duration: 3000,
                maskClickable: false
              });
            });
          }).catch(function (e) {
            Toast.show({
              content: e,
              duration: 3000,
              maskClickable: false
            });
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handlePay(_x) {
    return _ref.apply(this, arguments);
  };
}();
// 创建订单
export var handleCreateOrder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(props) {
    var _props$isFree, isFree, search, userInfo, product, productInfo, payType, closePayModal, _ref3, activityDetail, products, hasBuy, orderProduct, disabled, productType, isTrial, skipPayment, _ref4, projectId, originStr, searchParse, _activityDetail$chann, answer, user, params, roomId, data, _data$result, id, orderToken, url, _props$customFns6, _sessionStorage, sessionItem;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          console.log(props, 'props123');
          _props$isFree = props.isFree, isFree = _props$isFree === void 0 ? false : _props$isFree, search = props.search, userInfo = props.userInfo, product = props.product, productInfo = props.productInfo, payType = props.payType, closePayModal = props.closePayModal;
          _ref3 = productInfo || {}, activityDetail = _ref3.activity, products = _ref3.products, hasBuy = _ref3.hasBuy, orderProduct = _ref3.orderProduct, disabled = _ref3.hasDisabled, productType = _ref3.productType, isTrial = _ref3.isTrial, skipPayment = _ref3.skipPayment;
          _ref4 = activityDetail || {}, projectId = _ref4.projectId;
          _context3.prev = 4;
          originStr = window.location.origin;
          searchParse = qs.parse(search);
          if (!searchParse['x_field_1']) {
            searchParse['x_field_1'] = activityDetail === null || activityDetail === void 0 ? void 0 : (_activityDetail$chann = activityDetail['channelDeliveryVersion']) === null || _activityDetail$chann === void 0 ? void 0 : _activityDetail$chann['xField'];
          }
          answer = LStorage.get('qaAnswer'); // 用户信息
          user = {
            phoneArea: '',
            phoneNum: userInfo === null || userInfo === void 0 ? void 0 : userInfo.Phone
          };
          params = _objectSpread({
            isCreateOrder: true,
            activityId: activityDetail.id,
            productId: product.id,
            activityUri: "".concat(originStr).concat(window.location.pathname, "?").concat(qs.stringify(searchParse)),
            nickname: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.TrueName) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.NickName) || 'GD_',
            orderAgreement: 1,
            orderId: 0,
            paySource: '',
            payType: isFree || product.price === 0 ? 3 : 0,
            // 如果需付款为0，设置支付方式为3（免费）
            remark: '',
            versionNumber: activityDetail.versionNumber,
            returnUrl: originStr + '/success',
            surveyDto: answer
          }, user);
          roomId = getCookie(ROOM_ID); // 有roomId && 登录
          if (roomId && userInfo !== null && userInfo !== void 0 && userInfo.accessToken) {
            params.studioId = roomId;
          }
          // 创建订单
          Toast.show({
            content: '正在创建订单',
            duration: 10000,
            icon: 'loading'
          });
          _context3.next = 16;
          return createOrderOnly(params);
        case 16:
          data = _context3.sent;
          Toast.clear();
          if (data.status) {
            _context3.next = 33;
            break;
          }
          sensorsTrack('SCRM_orderpay_payfor_click', {
            scrm_activity_way: activityDetail.activityWay,
            scrm_activity_name: activityDetail.name,
            scrm_activity_id: activityDetail.id,
            scrm_product_name: product.productName || '',
            scrm_plan_name: activityDetail.planName,
            scrm_plan_id: activityDetail.planId,
            scrm_xField: searchParse['x_field_1'] || ''
          });
          _data$result = data.result, id = _data$result.id, orderToken = _data$result.orderToken; // 体验链接直接跳转到轻课详情
          if (!isFree) {
            _context3.next = 25;
            break;
          }
          Toast.show({
            content: '请稍后',
            duration: 2000,
            icon: 'loading'
          });
          setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var _props$customFns4, _props$customFns5, _props$customFns5$han;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  (_props$customFns4 = props.customFns) === null || _props$customFns4 === void 0 ? void 0 : _props$customFns4.initProductInfo();
                  (_props$customFns5 = props.customFns) === null || _props$customFns5 === void 0 ? void 0 : (_props$customFns5$han = _props$customFns5.handleStudy) === null || _props$customFns5$han === void 0 ? void 0 : _props$customFns5$han.call(_props$customFns5, {
                    productType: productType,
                    hasBuy: hasBuy,
                    orderProduct: orderProduct
                  });
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          })), 2000);
          return _context3.abrupt("return");
        case 25:
          url = "/success/".concat(orderToken);
          if (product.price) {
            _context3.next = 30;
            break;
          }
          (_props$customFns6 = props.customFns) === null || _props$customFns6 === void 0 ? void 0 : _props$customFns6.push(url);
          _context3.next = 31;
          break;
        case 30:
          return _context3.abrupt("return", handlePay(_objectSpread({
            orderInfo: data.result
          }, props)));
        case 31:
          _context3.next = 34;
          break;
        case 33:
          if (data.status === 16013221) {
            // 已有订单且未支付
            Toast.show({
              content: data === null || data === void 0 ? void 0 : data.info,
              duration: 2000,
              icon: 'loading'
            });
            sessionItem = JSON.parse(((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem('ProjectInfo')) || '');
            setTimeout(function () {
              if (window) window.location.href = (activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.templateType) === 7 ? "/orderlist" : "/orderdetail/".concat(data.result).concat(sessionItem && '?' + qs.stringify(sessionItem));
            }, 1000);
          } else if (data.status === 16013209) {
            // 已经参加过活动
            Toast.show({
              content: data === null || data === void 0 ? void 0 : data.info,
              duration: 3000,
              icon: 'loading'
            });
            closePayModal === null || closePayModal === void 0 ? void 0 : closePayModal();
            setTimeout(function () {
              var _props$customFns7;
              (_props$customFns7 = props.customFns) === null || _props$customFns7 === void 0 ? void 0 : _props$customFns7.initProductInfo();
            }, 1000);
          } else if (data.status === 16013211) {
            console.log('16013211');
            createModal(projectId);
          } else {
            Toast.show({
              content: data === null || data === void 0 ? void 0 : data.info,
              duration: 3000,
              icon: 'fail',
              maskClickable: false
            });
            closePayModal === null || closePayModal === void 0 ? void 0 : closePayModal();
          }
        case 34:
          _context3.next = 39;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t0 = _context3["catch"](4);
          Toast.show({
            content: _context3.t0,
            duration: 1500,
            icon: 'fail'
          });
        case 39:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[4, 36]]);
  }));
  return function handleCreateOrder(_x2) {
    return _ref2.apply(this, arguments);
  };
}();